export const NS_CONFIGURATION = 'conf';
export const NS_SERVICES = '__serv';

export const COMPANY = 'COMPANY';
export const PROJECT = 'PROJECT';
export const EDITOR = 'EDITOR';
export const FIELDSET = 'FIELDSET';
export const CREATOR = 'CREATOR';
export const VIEWER = 'VIEWER';
export const GENERAL = 'GENERAL';
export const SPRINT = 'SPRINT';
export const TEAM = 'TEAM';
export const USER = 'USER';
export const ITEM = 'ITEM';
export const CURRENT = 'CURRENT';
export const STATUS = 'STATUS';
export const TAG = 'TAG';
export const BOARD = 'BOARD';
export const PERSONAL = 'PERSONAL';
export const CATEGORY = 'CATEGORY';
export const TEMPLATE = 'TEMPLATE';


export const API = 'API';
export const HISTORY = 'HISTORY';
export const STORAGE = 'STORAGE';



// WEBPACK FOOTER //
// ../redux/constants.js